// src/components/AccountChecker/AccountCheckerHero.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const AccountCheckerHero = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <section className="checker-hero-wrap">
      <h1 className="checker-hero-title">
        STORM <span className="checker-hero-title-accent">CHECK</span>
      </h1>
      <p className="checker-hero-subtitle">
        {isEn
          ? 'Enter a Minecraft username to look up corresponding credentials in our comprehensive database of compromised accounts.'
          : 'Введите имя пользователя Minecraft для поиска соответствующих учетных данных в нашей комплексной базе данных скомпрометированных аккаунтов.'}
      </p>
    </section>
  );
};

export default AccountCheckerHero;
